<template>

  <v-container class="privatstep3 pa-0" fluid>

    <div class="semanticsection-title2 primary--text first">Antragsteller</div>

    <versicherungs-nehmer state-path="b.vn"
                          form-ref="vn-form" />

    <template v-if="this.$store.getters.hasMvp('b')">

      <div class="semanticsection-title2 primary--text">Mitversicherte Person (Lebenspartner/in)</div>

      <versicherungs-nehmer id="mvpdiv"
                            state-path="b.mvp"
                            form-ref="mvp-form" />

    </template>

    <div class="semanticsection-title2 primary--text">Beitragszahlung</div>

    <praemien-zahlung state-path="b"
                      form-ref="zahlung-form" />

    <v-row class="stepperbuttons">
      <v-btn id="back3"
             color="primary"
             class="standard-button"
             @click="$emit('step-back')">Zurück
      </v-btn>
      <v-spacer />
      <v-btn id="next3"
             color="primary"
             class="standard-button"
             @click="$emit('step-forward')">Weiter
      </v-btn>
    </v-row>
  </v-container>

</template>

<script>
import VersicherungsNehmer from "@/components/privatkundenrechner/Person.vue";
import PraemienZahlung from "@/components/privatkundenrechner/Praemienzahlung.vue";

export default {
  name: "PrivatStep3",
  components: { VersicherungsNehmer, PraemienZahlung }
};
</script>
<style>
.privatstep3 .step2--header {
  font-size: 24px;
  font-weight: 300;
}
</style>
